import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
} from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setBloodProductAdministrationQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)

  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  try {
    yield put(setDateTime(savedTimeString, currentDate))
    yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
    yield put(setSuccessfulAttempt(true))
    yield put(setAttempts('1'))
  } catch (e) {
    yield put(throwPcrException(`setBloodProductAdministrationQuickAction() error: ${e}`))
  }
}

export function* setBloodProductAdministrationQuickActionSaga() {
  yield takeLatest(
    [QuickActionsConstants.SET_IS_BLOOD_PRODUCT_ADMINISTRATION_BUTTON_TYPE],
    performWithMutexHOG,
    setBloodProductAdministrationQuickAction
  )
}
